
  // const $cards = document?.querySelectorAll('.as-card')
  // const nums = $cards.length
  // const cardWidth = document?.querySelector('.as-card')?.offsetWidth * (nums - 1)
  const vh = window.screen.availHeight
  var isMdPc = true
  if (window.innerWidth <= 1000) {
    isMdPc = false
  }
  if (isMdPc) {
    const $horizontalSrcollWrap = document?.querySelector('.as-horizontal-scroll-wrap')
    const $trigger = document?.querySelector('.as-horizontal-scroll-trigger')
    const $targetEle = document?.querySelector('.as-card-content')
    const blockSize = Number($trigger.dataset.blockSize)
    const bgTime = blockSize / 10
    const $videoAll = $horizontalSrcollWrap.querySelectorAll('.as-video')
    const $coverImageAll = $horizontalSrcollWrap.querySelectorAll('.as-cover-image')
    $videoAll.forEach(($video, index) => {
      $video.addEventListener('loadeddata', () => {
        $coverImageAll[index].style.opacity = 0
      });
    })
    // const blockSize = 5
    if (blockSize > 1) {
      let end = (blockSize + 0.8) * vh
      // 横向滚动
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: $trigger,
          start: `top 0px`,
          end: `+=${end}`,
          scrub: true,
          // markers: {startColor: "yellow", endColor: "yellow"}
        }
      })
      // tl.to('.as-card-content', { x: `-${cardWidth}px` })
      // tl.to($targetEle, { x: `-${(blockSize - 1) * 100}%` })
      tl.to($targetEle, { x: `-${100 - 100/blockSize}%`, duration:  blockSize})
      // tl.to($horizontalSrcollWrap, { backgroundColor: 'white', duration: bgTime },)
    
    }
  }

